import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import './toolbar.scss'

class Toolbar extends PureComponent {
	render() {
		const {
			children,
			position,
			toolbarRef,
			className,
			...rest
		} = this.props

		const toolbarClass = 'o-toolbar'
		const cssClasses = classNames(
			toolbarClass,
			position && `${toolbarClass}--${position}`,
			className
		)

		return (
			<div className={cssClasses} ref={toolbarRef} {...rest}>
				<div className={`${toolbarClass}__inner`}>{children}</div>
			</div>
		)
	}
}

Toolbar.propTypes = {
	children: PropTypes.node,
	position: PropTypes.string,
	className: PropTypes.string,
}

Toolbar.defaultProps = {
	children: null,
	position: null,
	className: null,
}

export default Toolbar
